<script lang="ts">
  export let className: string = ""
</script>

<svg
  class={className}
  stroke-width="2"
  viewBox="0 0 24 24"
  stroke-linecap="round"
  stroke-linejoin="round"
  height="1em"
  width="1em"
  xmlns="http://www.w3.org/2000/svg"
  ><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path
    d="M9 15v-6l7.745 10.65a9 9 0 1 1 2.255 -1.993"
  ></path><path d="M15 12v-3"></path></svg
>
